module.exports = __webpack_public_path__ + "static/media/user-pic.9505b3cb.png";